import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SttSortingService {
  constructor() {}

  checkNumber(num) {
    if (
      num == "1" ||
      num == "2" ||
      num == "3" ||
      num == "4" ||
      num == "5" ||
      num == "6" ||
      num == "7" ||
      num == "8" ||
      num == "9" ||
      num == "0"
    ) {
      return true;
    } else {
      return false;
    }
  }

  onlyLetters(str) {
    return /^[a-zA-Z\s]+$/.test(str);
  }

  isFootnote(a) {
    return a.paraType?.toLowerCase()?.includes("footnote");
  }

  onlyGlossary(a) {
    return (
      a.paraType?.toLowerCase()?.includes("glossary") ||
      a.paraType?.toLowerCase()?.includes("glossterm")
    );
  }
  //// Test cases
  //const input1 = 'Appendix 4-3'; //true
  //const input2 = 'Appendix 5-1'; //true
  //const input3 = 'Appendix 12-2'; //true
  //const input4 = 'Appendix BZ'; //false
  //const input5 = 'Appendix B2'; //false
  matchAppendixPattern(input): boolean {
    const regex = /^Appendix \d+-\d+$/;
    return regex.test(input);
  }
  SortSTTbyPronouncement(a: any, b: any) {
    let comparatorResult = 0;
    let spanA = document.createElement("span");
    spanA.innerHTML = a.pronouncement;
    let x = spanA.innerText.trim();
    let spanB = document.createElement("span");
    spanB.innerHTML = b.pronouncement;
    let y = spanB.innerText.trim();
    //Start - Added this code to correct sorting order MS-689
    // Summary:
    // pattern QZ.CN.NN causing issue with sorting order where C: Character & N:Number
    // Ex: 1) QZ.I1.1
    //     2) QZ.I2.1

    if (x.includes("QZ.I")) x = x.replace("QZ.I", "QZ.9999");
    if (y.includes("QZ.I")) y = y.replace("QZ.I", "QZ.9999");
    if (this.matchAppendixPattern(x)) {
      x = x.replace("Appendix ", "Appendix _");
    }
    if (this.matchAppendixPattern(y)) {
      y = y.replace("Appendix ", "Appendix _");
    }
    if (x.includes("Appendix BZ")) x = x.replace(/BZ/g, "100000");
    if (y.includes("Appendix BZ")) y = y.replace(/BZ/g, "100000");
    if (x.includes("Appendix B")) x = x.replace(/B(\d+)/g, "999$1");
    if (y.includes("Appendix B")) y = y.replace(/B(\d+)/g, "999$1");
    if (x.includes("Appendix _")) x = x.replace(/_(\d+)/g, "99$1");
    if (y.includes("Appendix _")) y = y.replace(/_(\d+)/g, "99$1");
    if (x.includes("Appendix ")) x = x.replace(/-/g, ".");
    if (y.includes("Appendix ")) y = y.replace(/-/g, ".");
    //End - Added this code to correct sorting order MS-689

    if (x == "" && y != "") {
      comparatorResult = -1;
    } else if (x != "" && y == "") {
      comparatorResult = 1;
    } else if (
      !x.toLowerCase().includes("fn") &&
      y.toLowerCase().includes("fn")
    ) {
      comparatorResult = -1;
    } else if (
      x.toLowerCase().includes("fn") &&
      !y.toLowerCase().includes("fn")
    ) {
      comparatorResult = 1;
    }

    if (comparatorResult == 0) {
      if (x.includes("¶") || y.includes("¶")) {
        if (x.includes("¶") && y.includes("¶")) {
          x = x.replace("-", "–");
          y = y.replace("-", "–");
          if (
            this.checkNumber(x.split("")[1]) &&
            this.checkNumber(y.split("")[1])
          ) {
            if (!x.includes(".") && !y.includes(".")) {
              if (
                Number(x.split(" ")[0].replace("*", "").split("¶")[1]) ==
                  Number(y.split(" ")[0].replace("*", "").split("¶")[1]) &&
                x.replace("*", "").split("¶")[1].includes("–") &&
                y.replace("*", "").split("¶")[1].includes("–")
              ) {
                if (
                  x.charAt(x.length - 1) == "*" &&
                  y.charAt(y.length - 1) == "*"
                ) {
                  comparatorResult =
                    Number(x.replace("*", "").split("¶")[1]) -
                    Number(y.replace("*", "").split("¶")[1]);
                } else if (
                  x.charAt(x.length - 1) != "*" &&
                  y.charAt(y.length - 1) == "*"
                ) {
                  comparatorResult = -1;
                } else if (
                  x.charAt(x.length - 1) == "*" &&
                  y.charAt(y.length - 1) != "*"
                ) {
                  comparatorResult = 1;
                } else if (
                  x.charAt(x.length - 1) != "*" &&
                  y.charAt(y.length - 1) != "*"
                ) {
                  comparatorResult = 0;
                }
              } else {
                if (
                  x.replace("*", "").split("¶")[1].includes("–") &&
                  y.replace("*", "").split("¶")[1].includes("–")
                ) {
                  if (
                    Number(x.replace("*", "").split("¶")[1].split("–")[0]) ==
                    Number(y.replace("*", "").split("¶")[1].split("–")[0])
                  ) {
                    comparatorResult =
                      Number(x.replace("*", "").split("¶")[2]) -
                      Number(y.replace("*", "").split("¶")[2]);
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split("¶")[1].split("–")[0]) -
                      Number(y.replace("*", "").split("¶")[1].split("–")[0]);
                  }
                } else if (
                  !x.replace("*", "").split("¶")[1].includes("–") &&
                  y.replace("*", "").split("¶")[1].includes("–")
                ) {
                  if (
                    Number(x.replace("*", "").split("¶")[1]) ==
                    Number(y.replace("*", "").split("¶")[1].split("–")[0])
                  ) {
                    comparatorResult = -1;
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split("¶")[1].split(" ")[0]) -
                      Number(y.replace("*", "").split("¶")[1].split("–")[0]);
                  }
                } else if (
                  x.replace("*", "").split("¶")[1].includes("–") &&
                  !y.replace("*", "").split("¶")[1].includes("–")
                ) {
                  if (
                    Number(x.replace("*", "").split("¶")[1].split("–")[0]) ==
                    Number(y.replace("*", "").split("¶")[1])
                  ) {
                    comparatorResult = 1;
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split("¶")[1].split("–")[0]) -
                      Number(y.replace("*", "").split("¶")[1].split(" ")[0]);
                  }
                } else {
                  comparatorResult =
                    Number(x.split(" ")[0].replace("*", "").split("¶")[1]) -
                    Number(y.split(" ")[0].replace("*", "").split("¶")[1]);
                }
              }
            } else if (x.includes(".") && y.includes(".")) {
              if (
                Number(
                  x.split(" ")[0].replace("*", "").split("¶")[1].split(".")[0]
                ) ==
                Number(
                  y.split(" ")[0].replace("*", "").split("¶")[1].split(".")[0]
                )
              ) {
                if (
                  Number(x.replace("*", "").split("¶")[1].split(".")[1]) ==
                  Number(y.replace("*", "").split("¶")[1].split(".")[1])
                ) {
                  if (
                    x.charAt(x.length - 1) == "*" &&
                    y.charAt(y.length - 1) == "*"
                  ) {
                    comparatorResult =
                      Number(x.replace("*", "").split("¶")[1]) -
                      Number(y.replace("*", "").split("¶")[1]);
                  } else if (
                    x.charAt(x.length - 1) != "*" &&
                    y.charAt(y.length - 1) == "*"
                  ) {
                    comparatorResult = -1;
                  } else if (
                    x.charAt(x.length - 1) == "*" &&
                    y.charAt(y.length - 1) != "*"
                  ) {
                    comparatorResult = 1;
                  } else if (
                    x.charAt(x.length - 1) != "*" &&
                    y.charAt(y.length - 1) != "*"
                  ) {
                    comparatorResult = 0;
                  }
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("¶")[1].split(".")[1]) -
                    Number(y.replace("*", "").split("¶")[1].split(".")[1]);
                }
              } else {
                comparatorResult =
                  Number(
                    x.split(" ")[0].replace("*", "").split("¶")[1].split(".")[0]
                  ) -
                  Number(
                    y.split(" ")[0].replace("*", "").split("¶")[1].split(".")[0]
                  );
              }
            } else if (x.includes(".") && !y.includes(".")) {
              comparatorResult =
                Number(x.replace("*", "").split("¶")[1].split(".")[0]) -
                Number(y.replace("*", "").split("¶")[1]);
            } else if (!x.includes(".") && y.includes(".")) {
              comparatorResult =
                Number(x.replace("*", "").split("¶")[1]) -
                Number(y.replace("*", "").split("¶")[1].split(".")[0]);
            }
          } else if (
            !this.checkNumber(x.split("")[1]) &&
            this.checkNumber(y.split("")[1])
          ) {
            comparatorResult = 1;
          } else if (
            this.checkNumber(x.split("")[1]) &&
            !this.checkNumber(y.split("")[1])
          ) {
            comparatorResult = -1;
          } else {
            if (x.replace(/[^A-Za-z]/g, "") == y.replace(/[^A-Za-z]/g, "")) {
              comparatorResult =
                Number(x.replace(/\D/g, "")) - Number(y.replace(/\D/g, ""));
            } else {
              comparatorResult =
                x.replace(/[^A-Za-z]/g, "") > y.replace(/[^A-Za-z]/g, "")
                  ? 1
                  : x.replace(/[^A-Za-z]/g, "") == y.replace(/[^A-Za-z]/g, "")
                  ? 0
                  : -1;
            }
          }
        } else if (x.includes("¶") && !y.includes("¶")) {
          comparatorResult = -1;
        } else if (!x.includes("¶") && y.includes("¶")) {
          comparatorResult = 1;
        }
      }
    }
    if (comparatorResult == 0) {
      if (x.charAt(0) == "Q" || y.charAt(0) == "Q") {
        if (x.includes("Q") && y.includes("Q")) {
          x = x.replace("-", "–");
          y = y.replace("-", "–");
          if (x.includes("–")) {
            x = x.split("–")[0];
          }
          if (y.includes("–")) {
            y = y.split("–")[0];
          }
          if (
            this.checkNumber(x.split("")[1]) &&
            this.checkNumber(y.split("")[1])
          ) {
            if (
              x.replace("*", "").split("Q")[1] ==
              y.replace("*", "").split("Q")[1]
            ) {
              if (
                x.charAt(x.length - 1) == "*" &&
                y.charAt(y.length - 1) == "*"
              ) {
                comparatorResult =
                  Number(x.replace("*", "").split("Q")[1]) -
                  Number(y.replace("*", "").split("Q")[1]);
              } else if (
                x.charAt(x.length - 1) != "*" &&
                y.charAt(y.length - 1) == "*"
              ) {
                comparatorResult = -1;
              } else if (
                x.charAt(x.length - 1) == "*" &&
                y.charAt(y.length - 1) != "*"
              ) {
                comparatorResult = 1;
              } else if (
                (x.charAt(x.length - 1) != "*") &&
                (y.charAt(y.length - 1) != "*")
              ) {
                comparatorResult = 0;
              }
            } else {
              if (x.includes(".") && y.includes(".")) {
                if (
                  x.replace("*", "").split("Q")[1].split(".")[0] ==
                  y.replace("*", "").split("Q")[1].split(".")[0]
                ) {
                  if (
                    Number(x.replace("*", "").split("Q")[1].split(".")[1]) ==
                    Number(y.replace("*", "").split("Q")[1].split(".")[1])
                  ) {
                    if (x.split(".").length > 2 && y.split(".").length > 2) {
                      if (
                        x.replace("*", "").split("Q")[1].split(".")[2] ==
                        y.replace("*", "").split("Q")[1].split(".")[2]
                      ) {
                        if (
                          (x.charAt(x.length - 1) != "*") &&
                          y.charAt(y.length - 1) == "*"
                        ) {
                          comparatorResult = 1;
                        } else if (
                          x.charAt(x.length - 1) == "*" &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = -1;
                        } else if (
                          (x.charAt(x.length - 1) != "*") &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = 0;
                        }
                      } else {
                        if (
                          x
                            .replace("*", "")
                            .split("Q")[1]
                            .split(".")[2]
                            .split(",")[0] ==
                          y
                            .replace("*", "")
                            .split("Q")[1]
                            .split(".")[2]
                            .split(",")[0]
                        ) {
                          if (
                            (x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                              y
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .includes("amended")) ||
                            (!x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                              !y
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .includes("amended"))
                          ) {
                            comparatorResult =
                              x.replace("*", "").split("Q")[1].split(".")[2] >
                              y.replace("*", "").split("Q")[1].split(".")[2]
                                ? 1
                                : x
                                    .replace("*", "")
                                    .split("Q")[1]
                                    .split(".")[2] ==
                                  y.replace("*", "").split("Q")[1].split(".")[2]
                                ? 0
                                : -1;
                          } else if (
                            !x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                            y
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended")
                          ) {
                            comparatorResult = -1;
                          } else if (
                            x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                            !y
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended")
                          ) {
                            comparatorResult = 1;
                          }
                        } else {
                          comparatorResult =
                            Number(
                              x
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .split(",")[0]
                            ) -
                            Number(
                              y
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .split(",")[0]
                            );
                        }
                      }
                    }
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split("Q")[1].split(".")[1]) -
                      Number(y.replace("*", "").split("Q")[1].split(".")[1]);
                  }
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (!x.includes(".") && y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = -1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (x.includes(".") && !y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = 1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else {
                comparatorResult =
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                  Number(y.replace("*", "").split("Q")[1].split(".")[0]);
              }
            }
          } else if (
            !this.checkNumber(x.split("")[1]) &&
            this.checkNumber(y.split("")[1])
          ) {
            if (x.split("")[1] == ".") {
              comparatorResult = -1;
            } else {
              comparatorResult = 1;
            }
          } else if (
            this.checkNumber(x.split("")[1]) &&
            !this.checkNumber(y.split("")[1])
          ) {
            if (y.split("")[1] == ".") {
              comparatorResult = 1;
            } else {
              comparatorResult = -1;
            }
          } else {
            if (x.split("")[1] == y.split("")[1]) {
              if (x.includes(".") && y.includes(".")) {
                if (
                  x.replace("*", "").split("Q")[1].split(".")[0] ==
                  y.replace("*", "").split("Q")[1].split(".")[0]
                ) {
                  if (
                    Number(x.replace("*", "").split(".")[1]) ==
                    Number(y.replace("*", "").split(".")[1])
                  ) {
                    if (x.split(".").length > 2 && y.split(".").length > 2) {
                      if (
                        x.replace("*", "").split(".")[2] ==
                        y.replace("*", "").split(".")[2]
                      ) {
                        if (
                          (x.charAt(x.length - 1) != "*") &&
                          y.charAt(y.length - 1) == "*"
                        ) {
                          comparatorResult = 1;
                        } else if (
                          x.charAt(x.length - 1) == "*" &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = -1;
                        } else if (
                          (x.charAt(x.length - 1) != "*") &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = 0;
                        }
                      } else {
                        if (
                          x.replace("*", "").split(".")[2].split(",")[0] ==
                          y.replace("*", "").split(".")[2].split(",")[0]
                        ) {
                          if (
                            (x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                              y
                                .replace("*", "")
                                .split(".")[2]
                                .includes("amended")) ||
                            (!x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                              !y
                                .replace("*", "")
                                .split(".")[2]
                                .includes("amended"))
                          ) {
                            comparatorResult =
                              x.replace("*", "").split(".")[2] >
                              y.replace("*", "").split(".")[2]
                                ? 1
                                : x.replace("*", "").split(".")[2] ==
                                  y.replace("*", "").split(".")[2]
                                ? 0
                                : -1;
                          } else if (
                            !x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                            y.replace("*", "").split(".")[2].includes("amended")
                          ) {
                            comparatorResult = -1;
                          } else if (
                            x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                            !y
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended")
                          ) {
                            comparatorResult = 1;
                          }
                        } else {
                          comparatorResult =
                            Number(
                              x.replace("*", "").split(".")[2].split(",")[0]
                            ) -
                            Number(
                              y.replace("*", "").split(".")[2].split(",")[0]
                            );
                        }
                      }
                    }
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split(".")[1]) -
                      Number(y.replace("*", "").split(".")[1]);
                  }
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (!x.includes(".") && y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = -1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (x.includes(".") && !y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = 1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else {
                comparatorResult =
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                  Number(y.replace("*", "").split("Q")[1].split(".")[0]);
              }
            } else {
              comparatorResult =
                Number(x.substr(2, x.length - 2)) -
                Number(y.substr(2, y.length - 2));
            }
          }
        } else if (!x.includes("Q") && y.includes("Q")) {
          comparatorResult = 1;
        } else if (x.includes("Q") && !y.includes("Q")) {
          comparatorResult = -1;
        }
      }
    }
    if (comparatorResult == 0) {
      if (x.toLowerCase().includes("fn") || y.toLowerCase().includes("fn")) {
        if (x.toLowerCase().includes("fn") && y.toLowerCase().includes("fn")) {
          x = x.replace("–", "-");
          y = y.replace("–", "-");
          if (
            this.checkNumber(
              x.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            ) &&
            this.checkNumber(
              y.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            )
          ) {
            if (
              Number(
                x.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
              ) ==
              Number(
                y.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
              )
            ) {
              if (
                x.toLowerCase().replace("*", "").split("fn")[1].includes("-") &&
                y.toLowerCase().replace("*", "").split("fn")[1].includes("-")
              ) {
                if (
                  Number(x.toLowerCase().replace("*", "").split("fn")[2]) ==
                  Number(y.toLowerCase().replace("*", "").split("fn")[2])
                ) {
                  if (
                    (x.charAt(x.length - 1) != "*") &&
                    y.charAt(y.length - 1) == "*"
                  ) {
                    comparatorResult = 1;
                  } else if (
                    x.charAt(x.length - 1) == "*" &&
                    (y.charAt(y.length - 1) != "*")
                  ) {
                    comparatorResult = -1;
                  }
                } else {
                  comparatorResult =
                    Number(x.toLowerCase().replace("*", "").split("fn")[2]) -
                    Number(y.toLowerCase().replace("*", "").split("fn")[2]);
                }
              } else {
                if (
                  (x.includes("*") && y.includes("*")) ||
                  (!x.includes("*") && !y.includes("*"))
                ) {
                  comparatorResult =
                    Number(x.toLowerCase().replace("*", "").split("fn")[1]) -
                    Number(y.toLowerCase().replace("*", "").split("fn")[1]);
                } else if (
                  (x.charAt(x.length - 1) != "*") &&
                  y.charAt(y.length - 1) == "*"
                ) {
                  comparatorResult = 1;
                } else if (
                  x.charAt(x.length - 1) == "*" &&
                  (y.charAt(y.length - 1) != "*")
                ) {
                  comparatorResult = -1;
                }
              }
            } else {
              comparatorResult =
                Number(
                  x.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
                ) -
                Number(
                  y.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
                );
            }
          } else if (
            !this.checkNumber(
              x.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            ) &&
            this.checkNumber(
              y.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            )
          ) {
            comparatorResult = 1;
          } else if (
            this.checkNumber(
              x.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            ) &&
            !this.checkNumber(
              y.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            )
          ) {
            comparatorResult = -1;
          } else {
            comparatorResult =
              Number(x.toLowerCase().substr(2, x.length - 2)) -
              Number(y.toLowerCase().substr(2, y.length - 2));
          }
        } else if (
          !x.toLowerCase().includes("fn") &&
          y.toLowerCase().includes("fn")
        ) {
          comparatorResult = 1;
        } else if (
          x.toLowerCase().includes("fn") &&
          !y.toLowerCase().includes("fn")
        ) {
          comparatorResult = -1;
        }
      }
    }
    if (
      comparatorResult == 0 &&
      x.charAt(0) != "¶" &&
      x.charAt(0) != "Q" &&
      x.charAt(0).toLowerCase() != "f"
    ) {
      if (
        !this.checkNumber(x.split("")[0]) ||
        !this.checkNumber(y.split("")[0])
      ) {
        if (
          !this.checkNumber(x.split("")[0]) &&
          !this.checkNumber(y.split("")[0])
        ) {
          if (x.includes(" ") && y.includes(" ")) {
            if (x.split(" ")[0] == y.split(" ")[0]) {
              if (
                x.split(" ")[1].includes("-") &&
                y.split(" ")[1].includes("-")
              ) {
                if (
                  x.split(" ")[1].split("-")[0] == y.split(" ")[1].split("-")[0]
                ) {
                  comparatorResult =
                    Number(x.split(" ")[1].split("-")[1]) -
                    Number(y.split(" ")[1].split("-")[1]);
                } else {
                  comparatorResult =
                    Number(x.split(" ")[1].split("-")[0]) -
                    Number(y.split(" ")[1].split("-")[0]);
                }
              } else {
                if (x.includes(", Ex") && y.includes(", Ex")) {
                  if (x.split(" ")[1] == y.split(" ")[1]) {
                    comparatorResult =
                      Number(
                        x.split(" ")[x.split(" ").length - 1].split("–")[0]
                      ) -
                      Number(
                        y.split(" ")[y.split(" ").length - 1].split("–")[0]
                      );
                  } else {
                    comparatorResult =
                      x.split(" ")[1] > y.split(" ")[1]
                        ? 1
                        : x.split(" ")[1] == y.split(" ")[1]
                        ? 0
                        : -1;
                  }
                } else {
                  comparatorResult =
                    Number(x.split(" ")[1]) - Number(y.split(" ")[1]);
                }
              }
            } else {
              comparatorResult =
                x.split(" ")[0] > y.split(" ")[0]
                  ? 1
                  : x.split(" ")[0] == y.split(" ")[0]
                  ? 0
                  : -1;
            }
          } else if (!x.includes(" ") && y.includes(" ")) {
            if (x == y.split(" ")[0]) {
              comparatorResult = -1;
            } else {
              comparatorResult = x > y.split(" ")[0] ? 1 : -1;
            }
          } else if (x.includes(" ") && !y.includes(" ")) {
            if (x.split(" ")[0] == y) {
              comparatorResult = 1;
            } else {
              comparatorResult = x.split(" ")[0] > y ? 1 : -1;
            }
          } else {
            comparatorResult =
              x.replace("*", "") > y.replace("*", "")
                ? 1
                : x.replace("*", "") == y.replace("*", "")
                ? 0
                : -1;
          }
        } else if (
          !this.checkNumber(x.split("")[0]) &&
          this.checkNumber(y.split("")[0])
        ) {
          comparatorResult = -1;
        } else if (
          this.checkNumber(x.split("")[0]) &&
          !this.checkNumber(y.split("")[0])
        ) {
          comparatorResult = 1;
        }
      }
    }
    if (comparatorResult == 0) {
      if (
        (x.includes("*") && y.includes("*")) ||
        (!x.includes("*") && !y.includes("*"))
      ) {
        if (x.includes(".") && y.includes(".")) {
          if (
            x.replace("*", "").split(".")[0] == y.replace("*", "").split(".")[0]
          ) {
            if (
              Number(x.replace("*", "").split(".")[1]) ==
              Number(y.replace("*", "").split(".")[1])
            ) {
              if (x.split(".").length > 2 && y.split(".").length > 2) {
                if (
                  x.replace("*", "").split(".")[2] ==
                  y.replace("*", "").split(".")[2]
                ) {
                  if (
                    (x.charAt(x.length - 1) != "*") &&
                    y.charAt(y.length - 1) == "*"
                  ) {
                    comparatorResult = 1;
                  } else if (
                    x.charAt(x.length - 1) == "*" &&
                    (y.charAt(y.length - 1) != "*")
                  ) {
                    comparatorResult = -1;
                  } else if (
                    (x.charAt(x.length - 1) != "*") &&
                    (y.charAt(y.length - 1) != "*")
                  ) {
                    comparatorResult = 0;
                  }
                } else {
                  if (
                    x.replace("*", "").split(".")[2].split(",")[0] ==
                    y.replace("*", "").split(".")[2].split(",")[0]
                  ) {
                    if (
                      (x.replace("*", "").split(".")[2].includes("amended") &&
                        y.replace("*", "").split(".")[2].includes("amended")) ||
                      (!x.replace("*", "").split(".")[2].includes("amended") &&
                        !y.replace("*", "").split(".")[2].includes("amended"))
                    ) {
                      comparatorResult =
                        x.replace("*", "").split(".")[2] >
                        y.replace("*", "").split(".")[2]
                          ? 1
                          : x.replace("*", "").split(".")[2] ==
                            y.replace("*", "").split(".")[2]
                          ? 0
                          : -1;
                    } else if (
                      !x.replace("*", "").split(".")[2].includes("amended") &&
                      y.replace("*", "").split(".")[2].includes("amended")
                    ) {
                      comparatorResult = -1;
                    } else if (
                      x.replace("*", "").split(".")[2].includes("amended") &&
                      !y.replace("*", "").split(".")[2].includes("amended")
                    ) {
                      comparatorResult = 1;
                    }
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split(".")[2].split(",")[0]) -
                      Number(y.replace("*", "").split(".")[2].split(",")[0]);
                  }
                }
              }
            } else {
              comparatorResult =
                Number(x.replace("*", "").split(".")[1]) -
                Number(y.replace("*", "").split(".")[1]);
            }
          } else {
            comparatorResult =
              Number(x.replace("*", "").split(".")[0]) -
              Number(y.replace("*", "").split(".")[0]);
          }
        } else if (!x.includes(".") && y.includes(".")) {
          if (
            Number(x.replace("*", "").split(".")[0]) ==
            Number(y.replace("*", "").split(".")[0])
          ) {
            comparatorResult = -1;
          } else {
            comparatorResult =
              Number(x.replace("*", "").split(".")[0]) -
              Number(y.replace("*", "").split(".")[0]);
          }
        } else if (x.includes(".") && !y.includes(".")) {
          if (
            Number(x.replace("*", "").split(".")[0]) ==
            Number(y.replace("*", "").split(".")[0])
          ) {
            comparatorResult = 1;
          } else {
            comparatorResult =
              Number(x.replace("*", "").split(".")[0]) -
              Number(y.replace("*", "").split(".")[0]);
          }
        } else {
          comparatorResult =
            Number(x.replace("*", "").split(".")[0].replace(/\D/g, "")) -
            Number(y.replace("*", "").split(".")[0].replace(/\D/g, ""));
        }
      } else if (!x.includes("*") && y.includes("*")) {
        if (x.replace("*", "") == y.replace("*", "")) {
          comparatorResult = -1;
        } else {
          comparatorResult =
            x.replace("*", "") > y.replace("*", "")
              ? 1
              : x.replace("*", "") == y.replace("*", "")
              ? 0
              : -1;
        }
      } else if (x.includes("*") && !y.includes("*")) {
        if (x.replace("*", "") == y.replace("*", "")) {
          comparatorResult = 1;
        } else {
          comparatorResult =
            x.replace("*", "") > y.replace("*", "")
              ? 1
              : x.replace("*", "") == y.replace("*", "")
              ? 0
              : -1;
        }
      }
    }
    return comparatorResult;
  }

  SortSTTbyParagraph(a: any, b: any, direction: any) {
    let comparatorResult = 0;
    let spanA = document.createElement("span");
    spanA.innerHTML = a.pronouncementPara;
    let x = spanA.innerText.trim();
    let spanB = document.createElement("span");
    spanB.innerHTML = b.pronouncementPara;
    let y = spanB.innerText.trim();
    //Start - Added this code to correct sorting order MS-689
    // Summary:
    // pattern QZ.CN.NN causing issue with sorting order where C: Character & N:Number
    // Ex: 1) QZ.I1.1
    //     2) QZ.I2.1
    if (x.includes("QZ.I")) x = x.replace("QZ.I", "QZ.9999");
    if (y.includes("QZ.I")) y = y.replace("QZ.I", "QZ.9999");
    if (this.matchAppendixPattern(x)) { x = x.replace("Appendix ", "Appendix _"); }
    if (this.matchAppendixPattern(y)) { y = y.replace("Appendix ", "Appendix _"); }
    if (x.includes("Appendix BZ")) x = x.replace(/BZ/g, '10000');
    if (y.includes("Appendix BZ")) y = y.replace(/BZ/g, '10000');
    if (x.includes("Appendix BZ")) { x = x.replace(/BZ/g, '100000'); }
    if (y.includes("Appendix BZ")) { y = y.replace(/BZ/g, '100000'); }
    if (x.includes("Appendix B")) x = x.replace(/B(\d+)/g, '999$1');
    if (y.includes("Appendix B")) y = y.replace(/B(\d+)/g, '999$1');
    if (x.includes("Appendix _")) x = x.replace(/_(\d+)/g, '99$1');
    if (y.includes("Appendix _")) y = y.replace(/_(\d+)/g, '99$1');
    if (x.includes("Appendix ")) x = x.replace(/-/g, '.');
    if (y.includes("Appendix ")) y = y.replace(/-/g, '.');
    //End - Added this code to correct sorting order MS-689
    if (x == "" && y != "") { comparatorResult = -1; }
    else if (x != "" && y == "") { comparatorResult = 1; }
    else if (!x.toLowerCase().includes("fn") && y.toLowerCase().includes("fn")) { comparatorResult = -1; }
    else if (x.toLowerCase().includes("fn") && !y.toLowerCase().includes("fn")) { comparatorResult = 1; }
    if (comparatorResult == 0) {
      if (x.includes("¶") || y.includes("¶")) {
        if (x.includes("¶") && y.includes("¶")) {
          x = x.replace("-", "–");
          y = y.replace("-", "–");
          if (
            this.checkNumber(x.split("")[1]) &&
            this.checkNumber(y.split("")[1])
          ) {
            if (!x.includes(".") && !y.includes(".")) {
              if (
                Number(x.split(" ")[0].replace("*", "").split("¶")[1]) ==
                  Number(y.split(" ")[0].replace("*", "").split("¶")[1]) &&
                x.replace("*", "").split("¶")[1].includes("–") &&
                y.replace("*", "").split("¶")[1].includes("–")
              ) {
                if (
                  x.charAt(x.length - 1) == "*" &&
                  y.charAt(y.length - 1) == "*"
                ) {
                  comparatorResult =
                    Number(x.replace("*", "").split("¶")[1]) -
                    Number(y.replace("*", "").split("¶")[1]);
                } else if (
                  x.charAt(x.length - 1) != "*" &&
                  y.charAt(y.length - 1) == "*"
                ) {
                  comparatorResult = -1;
                } else if (
                  x.charAt(x.length - 1) == "*" &&
                  y.charAt(y.length - 1) != "*"
                ) {
                  comparatorResult = 1;
                } else if (
                  x.charAt(x.length - 1) != "*" &&
                  y.charAt(y.length - 1) != "*"
                ) {
                  comparatorResult = 0;
                }
              } else {
                if (
                  x.replace("*", "").split("¶")[1].includes("–") &&
                  y.replace("*", "").split("¶")[1].includes("–")
                ) {
                  if (
                    Number(x.replace("*", "").split("¶")[1].split("–")[0]) ==
                    Number(y.replace("*", "").split("¶")[1].split("–")[0])
                  ) {
                    comparatorResult =
                      Number(x.replace("*", "").split("¶")[2]) -
                      Number(y.replace("*", "").split("¶")[2]);
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split("¶")[1].split("–")[0]) -
                      Number(y.replace("*", "").split("¶")[1].split("–")[0]);
                  }
                } else if (
                  !x.replace("*", "").split("¶")[1].includes("–") &&
                  y.replace("*", "").split("¶")[1].includes("–")
                ) {
                  if (
                    Number(x.replace("*", "").split("¶")[1]) ==
                    Number(y.replace("*", "").split("¶")[1].split("–")[0])
                  ) {
                    comparatorResult = -1;
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split("¶")[1]) -
                      Number(y.replace("*", "").split("¶")[1].split("–")[0]);
                  }
                } else if (
                  x.replace("*", "").split("¶")[1].includes("–") &&
                  !y.replace("*", "").split("¶")[1].includes("–")
                ) {
                  if (
                    Number(x.replace("*", "").split("¶")[1].split("–")[0]) ==
                    Number(y.replace("*", "").split("¶")[1])
                  ) {
                    comparatorResult = 1;
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split("¶")[1].split("–")[0]) -
                      Number(y.replace("*", "").split("¶")[1]);
                  }
                } else {
                  comparatorResult =
                    Number(x.split(" ")[0].replace("*", "").split("¶")[1]) -
                    Number(y.split(" ")[0].replace("*", "").split("¶")[1]);
                }
              }
            } else if (x.includes(".") && y.includes(".")) {
              if (
                Number(
                  x.split(" ")[0].replace("*", "").split("¶")[1].split(".")[0]
                ) ==
                Number(
                  y.split(" ")[0].replace("*", "").split("¶")[1].split(".")[0]
                )
              ) {
                if (
                  Number(x.replace("*", "").split("¶")[1].split(".")[1]) ==
                  Number(y.replace("*", "").split("¶")[1].split(".")[1])
                ) {
                  if (
                    x.charAt(x.length - 1) == "*" &&
                    y.charAt(y.length - 1) == "*"
                  ) {
                    comparatorResult =
                      Number(x.replace("*", "").split("¶")[1]) -
                      Number(y.replace("*", "").split("¶")[1]);
                  } else if (
                    x.charAt(x.length - 1) != "*" &&
                    y.charAt(y.length - 1) == "*"
                  ) {
                    comparatorResult = -1;
                  } else if (
                    x.charAt(x.length - 1) == "*" &&
                    y.charAt(y.length - 1) != "*"
                  ) {
                    comparatorResult = 1;
                  } else if (
                    x.charAt(x.length - 1) != "*" &&
                    y.charAt(y.length - 1) != "*"
                  ) {
                    comparatorResult = 0;
                  }
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("¶")[1].split(".")[1]) -
                    Number(y.replace("*", "").split("¶")[1].split(".")[1]);
                }
              } else {
                comparatorResult =
                  Number(
                    x.split(" ")[0].replace("*", "").split("¶")[1].split(".")[0]
                  ) -
                  Number(
                    y.split(" ")[0].replace("*", "").split("¶")[1].split(".")[0]
                  );
              }
            } else if (x.includes(".") && !y.includes(".")) {
              comparatorResult =
                Number(x.replace("*", "").split("¶")[1].split(".")[0]) -
                Number(y.replace("*", "").split("¶")[1]);
            } else if (!x.includes(".") && y.includes(".")) {
              comparatorResult =
                Number(x.replace("*", "").split("¶")[1]) -
                Number(y.replace("*", "").split("¶")[1].split(".")[0]);
            }
          } else if (
            !this.checkNumber(x.split("")[1]) &&
            this.checkNumber(y.split("")[1])
          ) {
            comparatorResult = 1;
          } else if (
            this.checkNumber(x.split("")[1]) &&
            !this.checkNumber(y.split("")[1])
          ) {
            comparatorResult = -1;
          } else {
            if (x.replace(/[^A-Za-z]/g, "") == y.replace(/[^A-Za-z]/g, "")) {
              comparatorResult =
                Number(x.replace(/\D/g, "")) - Number(y.replace(/\D/g, ""));
            } else {
              comparatorResult =
                x.replace(/[^A-Za-z]/g, "") > y.replace(/[^A-Za-z]/g, "")
                  ? 1
                  : x.replace(/[^A-Za-z]/g, "") == y.replace(/[^A-Za-z]/g, "")
                  ? 0
                  : -1;
            }
          }
        } else if (x.includes("¶") && !y.includes("¶")) {
          comparatorResult = -1;
        } else if (!x.includes("¶") && y.includes("¶")) {
          comparatorResult = 1;
        }
      }
    }
    if (comparatorResult == 0) {
      if (x.charAt(0) == "Q" || y.charAt(0) == "Q") {
        if (x.includes("Q") && y.includes("Q")) {
          if (
            this.checkNumber(x.split("")[1]) &&
            this.checkNumber(y.split("")[1])
          ) {
            if (
              x.replace("*", "").split("Q")[1] ==
              y.replace("*", "").split("Q")[1]
            ) {
              if (
                x.charAt(x.length - 1) == "*" &&
                y.charAt(y.length - 1) == "*"
              ) {
                comparatorResult =
                  Number(x.replace("*", "").split("Q")[1]) -
                  Number(y.replace("*", "").split("Q")[1]);
              } else if (
                x.charAt(x.length - 1) != "*" &&
                y.charAt(y.length - 1) == "*"
              ) {
                comparatorResult = -1;
              } else if (
                x.charAt(x.length - 1) == "*" &&
                y.charAt(y.length - 1) != "*"
              ) {
                comparatorResult = 1;
              } else if (
                (x.charAt(x.length - 1) != "*") &&
                (y.charAt(y.length - 1) != "*")
              ) {
                comparatorResult = 0;
              }
            } else {
              if (x.includes(".") && y.includes(".")) {
                if (
                  x.replace("*", "").split("Q")[1].split(".")[0] ==
                  y.replace("*", "").split("Q")[1].split(".")[0]
                ) {
                  if (
                    Number(x.replace("*", "").split("Q")[1].split(".")[1]) ==
                    Number(y.replace("*", "").split("Q")[1].split(".")[1])
                  ) {
                    if (x.split(".").length > 2 && y.split(".").length > 2) {
                      if (
                        x.replace("*", "").split("Q")[1].split(".")[2] ==
                        y.replace("*", "").split("Q")[1].split(".")[2]
                      ) {
                        if (
                          (x.charAt(x.length - 1) != "*") &&
                          y.charAt(y.length - 1) == "*"
                        ) {
                          comparatorResult = 1;
                        } else if (
                          x.charAt(x.length - 1) == "*" &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = -1;
                        } else if (
                          (x.charAt(x.length - 1) != "*") &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = 0;
                        }
                      } else {
                        if (
                          x
                            .replace("*", "")
                            .split("Q")[1]
                            .split(".")[2]
                            .split(",")[0] ==
                          y
                            .replace("*", "")
                            .split("Q")[1]
                            .split(".")[2]
                            .split(",")[0]
                        ) {
                          if (
                            (x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                              y
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .includes("amended")) ||
                            (!x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                              !y
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .includes("amended"))
                          ) {
                            comparatorResult =
                              x.replace("*", "").split("Q")[1].split(".")[2] >
                              y.replace("*", "").split("Q")[1].split(".")[2]
                                ? 1
                                : x
                                    .replace("*", "")
                                    .split("Q")[1]
                                    .split(".")[2] ==
                                  y.replace("*", "").split("Q")[1].split(".")[2]
                                ? 0
                                : -1;
                          } else if (
                            !x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                            y
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended")
                          ) {
                            comparatorResult = -1;
                          } else if (
                            x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                            !y
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended")
                          ) {
                            comparatorResult = 1;
                          }
                        } else {
                          comparatorResult =
                            Number(
                              x
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .split(",")[0]
                            ) -
                            Number(
                              y
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .split(",")[0]
                            );
                        }
                      }
                    }
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split("Q")[1].split(".")[1]) -
                      Number(y.replace("*", "").split("Q")[1].split(".")[1]);
                  }
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (!x.includes(".") && y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = -1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (x.includes(".") && !y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = 1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else {
                comparatorResult =
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                  Number(y.replace("*", "").split("Q")[1].split(".")[0]);
              }
            }
          } else if (
            !this.checkNumber(x.split("")[1]) &&
            this.checkNumber(y.split("")[1])
          ) {
            if (x.split("")[1] == ".") {
              comparatorResult = -1;
            } else {
              comparatorResult = 1;
            }
          } else if (
            this.checkNumber(x.split("")[1]) &&
            !this.checkNumber(y.split("")[1])
          ) {
            if (y.split("")[1] == ".") {
              comparatorResult = 1;
            } else {
              comparatorResult = -1;
            }
          } else {
            if (x.split("")[1] == y.split("")[1]) {
              if (x.includes(".") && y.includes(".")) {
                if (
                  x.replace("*", "").split("Q")[1].split(".")[0] ==
                  y.replace("*", "").split("Q")[1].split(".")[0]
                ) {
                  if (
                    Number(x.replace("*", "").split(".")[1]) ==
                    Number(y.replace("*", "").split(".")[1])
                  ) {
                    if (x.split(".").length > 2 && y.split(".").length > 2) {
                      if (
                        x.replace("*", "").split(".")[2] ==
                        y.replace("*", "").split(".")[2]
                      ) {
                        if (
                          (x.charAt(x.length - 1) != "*") &&
                          y.charAt(y.length - 1) == "*"
                        ) {
                          comparatorResult = 1;
                        } else if (
                          x.charAt(x.length - 1) == "*" &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = -1;
                        } else if (
                          (x.charAt(x.length - 1) != "*") &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = 0;
                        }
                      } else {
                        if (
                          x.replace("*", "").split(".")[2].split(",")[0] ==
                          y.replace("*", "").split(".")[2].split(",")[0]
                        ) {
                          if (
                            (x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                              y
                                .replace("*", "")
                                .split(".")[2]
                                .includes("amended")) ||
                            (!x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                              !y
                                .replace("*", "")
                                .split(".")[2]
                                .includes("amended"))
                          ) {
                            comparatorResult =
                              x.replace("*", "").split(".")[2] >
                              y.replace("*", "").split(".")[2]
                                ? 1
                                : x.replace("*", "").split(".")[2] ==
                                  y.replace("*", "").split(".")[2]
                                ? 0
                                : -1;
                          } else if (
                            !x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                            y.replace("*", "").split(".")[2].includes("amended")
                          ) {
                            comparatorResult = -1;
                          } else if (
                            x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                            !y
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended")
                          ) {
                            comparatorResult = 1;
                          }
                        } else {
                          comparatorResult =
                            Number(
                              x.replace("*", "").split(".")[2].split(",")[0]
                            ) -
                            Number(
                              y.replace("*", "").split(".")[2].split(",")[0]
                            );
                        }
                      }
                    }
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split(".")[1]) -
                      Number(y.replace("*", "").split(".")[1]);
                  }
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (!x.includes(".") && y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = -1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (x.includes(".") && !y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = 1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else {
                comparatorResult =
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                  Number(y.replace("*", "").split("Q")[1].split(".")[0]);
              }
            } else {
              comparatorResult =
                Number(x.substr(2, x.length - 2)) -
                Number(y.substr(2, y.length - 2));
            }
          }
        } else if (!x.includes("Q") && y.includes("Q")) {
          comparatorResult = 1;
        } else if (x.includes("Q") && !y.includes("Q")) {
          comparatorResult = -1;
        }
      }
    }
    if (comparatorResult == 0) {
      if (x.toLowerCase().includes("fn") || y.toLowerCase().includes("fn")) {
        if (x.toLowerCase().includes("fn") && y.toLowerCase().includes("fn")) {
          x = x.replace("–", "-");
          y = y.replace("–", "-");
          if (
            this.checkNumber(
              x.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            ) &&
            this.checkNumber(
              y.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            )
          ) {
            if (
              Number(
                x.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
              ) ==
              Number(
                y.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
              )
            ) {
              if (
                x.toLowerCase().replace("*", "").split("fn")[1].includes("-") &&
                y.toLowerCase().replace("*", "").split("fn")[1].includes("-")
              ) {
                if (
                  Number(x.toLowerCase().replace("*", "").split("fn")[2]) ==
                  Number(y.toLowerCase().replace("*", "").split("fn")[2])
                ) {
                  if (
                    (x.charAt(x.length - 1) != "*") &&
                    y.charAt(y.length - 1) == "*"
                  ) {
                    comparatorResult = 1;
                  } else if (
                    x.charAt(x.length - 1) == "*" &&
                    (y.charAt(y.length - 1) != "*")
                  ) {
                    comparatorResult = -1;
                  }
                } else {
                  comparatorResult =
                    Number(x.toLowerCase().replace("*", "").split("fn")[2]) -
                    Number(y.toLowerCase().replace("*", "").split("fn")[2]);
                }
              } else {
                if (
                  (x.includes("*") && y.includes("*")) ||
                  (!x.includes("*") && !y.includes("*"))
                ) {
                  comparatorResult =
                    Number(x.toLowerCase().replace("*", "").split("fn")[1]) -
                    Number(y.toLowerCase().replace("*", "").split("fn")[1]);
                } else if (
                  (x.charAt(x.length - 1) != "*") &&
                  y.charAt(y.length - 1) == "*"
                ) {
                  comparatorResult = 1;
                } else if (
                  x.charAt(x.length - 1) == "*" &&
                  (y.charAt(y.length - 1) != "*")
                ) {
                  comparatorResult = -1;
                }
              }
            } else {
              comparatorResult =
                Number(
                  x.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
                ) -
                Number(
                  y.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
                );
            }
          } else if (
            !this.checkNumber(
              x.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            ) &&
            this.checkNumber(
              y.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            )
          ) {
            comparatorResult = 1;
          } else if (
            this.checkNumber(
              x.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            ) &&
            !this.checkNumber(
              y.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            )
          ) {
            comparatorResult = -1;
          } else {
            comparatorResult =
              Number(x.toLowerCase().substr(2, x.length - 2)) -
              Number(y.toLowerCase().substr(2, y.length - 2));
          }
        } else if (
          !x.toLowerCase().includes("fn") &&
          y.toLowerCase().includes("fn")
        ) {
          comparatorResult = 1;
        } else if (
          x.toLowerCase().includes("fn") &&
          !y.toLowerCase().includes("fn")
        ) {
          comparatorResult = -1;
        }
      }
    }
    if (
      comparatorResult == 0 &&
      x.charAt(0) != "¶" &&
      x.charAt(0) != "Q" &&
      x.charAt(0).toLowerCase() != "f"
    ) {
      if (
        !this.checkNumber(x.split("")[0]) ||
        !this.checkNumber(y.split("")[0])
      ) {
        if (
          !this.checkNumber(x.split("")[0]) &&
          !this.checkNumber(y.split("")[0])
        ) {
          if (x.includes(" ") && y.includes(" ")) {
            if (x.split(" ")[0] == y.split(" ")[0]) {
              if (
                x.split(" ")[1].includes("-") &&
                y.split(" ")[1].includes("-")
              ) {
                if (
                  x.split(" ")[1].split("-")[0] == y.split(" ")[1].split("-")[0]
                ) {
                  comparatorResult =
                    Number(x.split(" ")[1].split("-")[1]) -
                    Number(y.split(" ")[1].split("-")[1]);
                } else {
                  comparatorResult =
                    Number(x.split(" ")[1].split("-")[0]) -
                    Number(y.split(" ")[1].split("-")[0]);
                }
              } else {
                if (x.includes(", Ex") && y.includes(", Ex")) {
                  if (x.split(" ")[1] == y.split(" ")[1]) {
                    comparatorResult =
                      Number(
                        x.split(" ")[x.split(" ").length - 1].split("–")[0]
                      ) -
                      Number(
                        y.split(" ")[y.split(" ").length - 1].split("–")[0]
                      );
                  } else {
                    comparatorResult =
                      x.split(" ")[1] > y.split(" ")[1]
                        ? 1
                        : x.split(" ")[1] == y.split(" ")[1]
                        ? 0
                        : -1;
                  }
                } else {
                  comparatorResult =
                    Number(x.split(" ")[1]) - Number(y.split(" ")[1]);
                }
              }
            } else {
              comparatorResult =
                x.split(" ")[0] > y.split(" ")[0]
                  ? 1
                  : x.split(" ")[0] == y.split(" ")[0]
                  ? 0
                  : -1;
            }
          } else if (!x.includes(" ") && y.includes(" ")) {
            if (x == y.split(" ")[0]) {
              comparatorResult = -1;
            } else {
              comparatorResult = x > y.split(" ")[0] ? 1 : -1;
            }
          } else if (x.includes(" ") && !y.includes(" ")) {
            if (x.split(" ")[0] == y) {
              comparatorResult = 1;
            } else {
              comparatorResult = x.split(" ")[0] > y ? 1 : -1;
            }
          } else {
            comparatorResult =
              x.replace("*", "") > y.replace("*", "")
                ? 1
                : x.replace("*", "") == y.replace("*", "")
                ? 0
                : -1;
          }
        } else if (
          !this.checkNumber(x.split("")[0]) &&
          this.checkNumber(y.split("")[0])
        ) {
          comparatorResult = -1;
        } else if (
          this.checkNumber(x.split("")[0]) &&
          !this.checkNumber(y.split("")[0])
        ) {
          comparatorResult = 1;
        }
      }
    }
    if (comparatorResult == 0) {
      if (
        (x.includes("*") && y.includes("*")) ||
        (!x.includes("*") && !y.includes("*"))
      ) {
        if (x.includes(".") && y.includes(".")) {
          if (
            x.replace("*", "").split(".")[0] == y.replace("*", "").split(".")[0]
          ) {
            if (
              Number(x.replace("*", "").split(".")[1]) ==
              Number(y.replace("*", "").split(".")[1])
            ) {
              if (x.split(".").length > 2 && y.split(".").length > 2) {
                if (
                  x.replace("*", "").split(".")[2] ==
                  y.replace("*", "").split(".")[2]
                ) {
                  if (
                    (x.charAt(x.length - 1) != "*") &&
                    y.charAt(y.length - 1) == "*"
                  ) {
                    comparatorResult = 1;
                  } else if (
                    x.charAt(x.length - 1) == "*" &&
                    (y.charAt(y.length - 1) != "*")
                  ) {
                    comparatorResult = -1;
                  } else if (
                    (x.charAt(x.length - 1) != "*") &&
                    (y.charAt(y.length - 1) != "*")
                  ) {
                    comparatorResult = 0;
                  }
                } else {
                  if (
                    x.replace("*", "").split(".")[2].split(",")[0] ==
                    y.replace("*", "").split(".")[2].split(",")[0]
                  ) {
                    if (
                      (x.replace("*", "").split(".")[2].includes("amended") &&
                        y.replace("*", "").split(".")[2].includes("amended")) ||
                      (!x.replace("*", "").split(".")[2].includes("amended") &&
                        !y.replace("*", "").split(".")[2].includes("amended"))
                    ) {
                      comparatorResult =
                        x.replace("*", "").split(".")[2] >
                        y.replace("*", "").split(".")[2]
                          ? 1
                          : x.replace("*", "").split(".")[2] ==
                            y.replace("*", "").split(".")[2]
                          ? 0
                          : -1;
                    } else if (
                      !x.replace("*", "").split(".")[2].includes("amended") &&
                      y.replace("*", "").split(".")[2].includes("amended")
                    ) {
                      comparatorResult = -1;
                    } else if (
                      x.replace("*", "").split(".")[2].includes("amended") &&
                      !y.replace("*", "").split(".")[2].includes("amended")
                    ) {
                      comparatorResult = 1;
                    }
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split(".")[2].split(",")[0]) -
                      Number(y.replace("*", "").split(".")[2].split(",")[0]);
                  }
                }
              }
            } else {
              comparatorResult =
                Number(x.replace("*", "").split(".")[1]) -
                Number(y.replace("*", "").split(".")[1]);
            }
          } else {
            comparatorResult =
              Number(x.replace("*", "").split(".")[0]) -
              Number(y.replace("*", "").split(".")[0]);
          }
        } else if (!x.includes(".") && y.includes(".")) {
          if (
            Number(x.replace("*", "").split(".")[0]) ==
            Number(y.replace("*", "").split(".")[0])
          ) {
            comparatorResult = -1;
          } else {
            comparatorResult =
              Number(x.replace("*", "").split(".")[0]) -
              Number(y.replace("*", "").split(".")[0]);
          }
        } else if (x.includes(".") && !y.includes(".")) {
          if (
            Number(x.replace("*", "").split(".")[0]) ==
            Number(y.replace("*", "").split(".")[0])
          ) {
            comparatorResult = 1;
          } else {
            comparatorResult =
              Number(x.replace("*", "").split(".")[0]) -
              Number(y.replace("*", "").split(".")[0]);
          }
        } else {
          comparatorResult =
            Number(x.replace("*", "").split(".")[0].replace(/\D/g, "")) -
            Number(y.replace("*", "").split(".")[0].replace(/\D/g, ""));
        }
      } else if (!x.includes("*") && y.includes("*")) {
        if (x.replace("*", "") == y.replace("*", "")) {
          comparatorResult = -1;
        } else {
          comparatorResult =
            x.replace("*", "") > y.replace("*", "")
              ? 1
              : x.replace("*", "") == y.replace("*", "")
              ? 0
              : -1;
        }
      } else if (x.includes("*") && !y.includes("*")) {
        if (x.replace("*", "") == y.replace("*", "")) {
          comparatorResult = 1;
        } else {
          comparatorResult =
            x.replace("*", "") > y.replace("*", "")
              ? 1
              : x.replace("*", "") == y.replace("*", "")
              ? 0
              : -1;
        }
      }
    }
    return comparatorResult * (direction == "asc" ? 1 : -1);
  }

  SortSTTbyChapter(a: any, b: any) {
    let comparatorResult = 0;
    let spanA = document.createElement("span");
    spanA.innerHTML = a.chapter;
    let x = spanA.innerText.trim();
    let spanB = document.createElement("span");
    spanB.innerHTML = b.chapter;
    let y = spanB.innerText.trim();
    //Start - Added this code to correct sorting order MS-689
    // Summary:
    // pattern QZ.CN.NN causing issue with sorting order where C: Character & N:Number
    // Ex: 1) QZ.I1.1
    //     2) QZ.I2.1
    if (x.includes("QZ.I")) x = x.replace("QZ.I", "QZ.9999");
    if (y.includes("QZ.I")) y = y.replace("QZ.I", "QZ.9999");
    if (this.matchAppendixPattern(x)) { x = x.replace("Appendix ", "Appendix _"); }
    if (this.matchAppendixPattern(y)) { y = y.replace("Appendix ", "Appendix _"); }
    if (x.includes("Appendix BZ")) x = x.replace(/BZ/g, '10000');
    if (y.includes("Appendix BZ")) y = y.replace(/BZ/g, '10000');
    if (x.includes("Appendix BZ")) { x = x.replace(/BZ/g, '100000'); }
    if (y.includes("Appendix BZ")) { y = y.replace(/BZ/g, '100000'); }
    if (x.includes("Appendix B")) x = x.replace(/B(\d+)/g, '999$1');
    if (y.includes("Appendix B")) y = y.replace(/B(\d+)/g, '999$1');
    if (x.includes("Appendix _")) x = x.replace(/_(\d+)/g, '99$1');
    if (y.includes("Appendix _")) y = y.replace(/_(\d+)/g, '99$1');
    if (x.includes("Appendix ")) x = x.replace(/-/g, '.');
    if (y.includes("Appendix ")) y = y.replace(/-/g, '.');
    //End - Added this code to correct sorting order MS-689
    if (x == "" && y != "") { comparatorResult = -1; }
    else if (x != "" && y == "") { comparatorResult = 1; }
    else if (!x.toLowerCase().includes("fn") && y.toLowerCase().includes("fn")) { comparatorResult = -1; }
    else if (x.toLowerCase().includes("fn") && !y.toLowerCase().includes("fn")) { comparatorResult = 1; }
    if (comparatorResult == 0) {
      if (x.charAt(0) == "Q" || y.charAt(0) == "Q") {
        if (x.includes("Q") && y.includes("Q")) {
          x = x.replace("-", "–");
          y = y.replace("-", "–");
          if (x.includes("–")) {
            x = x.split("–")[0];
          }
          if (y.includes("–")) {
            y = y.split("–")[0];
          }
          if (
            this.checkNumber(x.split("")[1]) &&
            this.checkNumber(y.split("")[1])
          ) {
            if (
              x.replace("*", "").split("Q")[1] ==
              y.replace("*", "").split("Q")[1]
            ) {
              if (
                x.charAt(x.length - 1) == "*" &&
                y.charAt(y.length - 1) == "*"
              ) {
                comparatorResult =
                  Number(x.replace("*", "").split("Q")[1]) -
                  Number(y.replace("*", "").split("Q")[1]);
              } else if (
                x.charAt(x.length - 1) != "*" &&
                y.charAt(y.length - 1) == "*"
              ) {
                comparatorResult = -1;
              } else if (
                x.charAt(x.length - 1) == "*" &&
                y.charAt(y.length - 1) != "*"
              ) {
                comparatorResult = 1;
              } else if (
                (x.charAt(x.length - 1) != "*") &&
                (y.charAt(y.length - 1) != "*")
              ) {
                comparatorResult = 0;
              }
            } else {
              if (x.includes(".") && y.includes(".")) {
                if (
                  x.replace("*", "").split("Q")[1].split(".")[0] ==
                  y.replace("*", "").split("Q")[1].split(".")[0]
                ) {
                  if (
                    Number(x.replace("*", "").split("Q")[1].split(".")[1]) ==
                    Number(y.replace("*", "").split("Q")[1].split(".")[1])
                  ) {
                    if (x.split(".").length > 2 && y.split(".").length > 2) {
                      if (
                        x.replace("*", "").split("Q")[1].split(".")[2] ==
                        y.replace("*", "").split("Q")[1].split(".")[2]
                      ) {
                        if (
                          (x.charAt(x.length - 1) != "*") &&
                          y.charAt(y.length - 1) == "*"
                        ) {
                          comparatorResult = 1;
                        } else if (
                          x.charAt(x.length - 1) == "*" &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = -1;
                        } else if (
                          (x.charAt(x.length - 1) != "*") &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = 0;
                        }
                      } else {
                        if (
                          x.replace("*", "").split("Q")[1].split(".")[2] ==
                          y.replace("*", "").split("Q")[1].split(".")[2]
                        ) {
                          if (
                            (x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                              y
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .includes("amended")) ||
                            (!x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                              !y
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .includes("amended"))
                          ) {
                            comparatorResult =
                              x.replace("*", "").split("Q")[1].split(".")[2] >
                              y.replace("*", "").split("Q")[1].split(".")[2]
                                ? 1
                                : x
                                    .replace("*", "")
                                    .split("Q")[1]
                                    .split(".")[2] ==
                                  y.replace("*", "").split("Q")[1].split(".")[2]
                                ? 0
                                : -1;
                          } else if (
                            !x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                            y
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended")
                          ) {
                            comparatorResult = -1;
                          } else if (
                            x
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended") &&
                            !y
                              .replace("*", "")
                              .split("Q")[1]
                              .split(".")[2]
                              .includes("amended")
                          ) {
                            comparatorResult = 1;
                          }
                        } else {
                          comparatorResult =
                            Number(
                              x
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .split(",")[0]
                            ) -
                            Number(
                              y
                                .replace("*", "")
                                .split("Q")[1]
                                .split(".")[2]
                                .split(",")[0]
                            );
                        }
                      }
                    }
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split("Q")[1].split(".")[1]) -
                      Number(y.replace("*", "").split("Q")[1].split(".")[1]);
                  }
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (!x.includes(".") && y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = -1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (x.includes(".") && !y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = 1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else {
                comparatorResult =
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                  Number(y.replace("*", "").split("Q")[1].split(".")[0]);
              }
            }
          } else if (
            !this.checkNumber(x.split("")[1]) &&
            this.checkNumber(y.split("")[1])
          ) {
            if (x.split("")[1] == ".") {
              comparatorResult = -1;
            } else {
              comparatorResult = 1;
            }
          } else if (
            this.checkNumber(x.split("")[1]) &&
            !this.checkNumber(y.split("")[1])
          ) {
            if (y.split("")[1] == ".") {
              comparatorResult = 1;
            } else {
              comparatorResult = -1;
            }
          } else {
            if (x.split("")[1] == y.split("")[1]) {
              if (x.includes(".") && y.includes(".")) {
                if (
                  x.replace("*", "").split("Q")[1].split(".")[0] ==
                  y.replace("*", "").split("Q")[1].split(".")[0]
                ) {
                  if (
                    Number(x.replace("*", "").split(".")[1]) ==
                    Number(y.replace("*", "").split(".")[1])
                  ) {
                    if (x.split(".").length > 2 && y.split(".").length > 2) {
                      if (
                        x.replace("*", "").split(".")[2] ==
                        y.replace("*", "").split(".")[2]
                      ) {
                        if (
                          (x.charAt(x.length - 1) != "*") &&
                          y.charAt(y.length - 1) == "*"
                        ) {
                          comparatorResult = 1;
                        } else if (
                          x.charAt(x.length - 1) == "*" &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = -1;
                        } else if (
                          (x.charAt(x.length - 1) != "*") &&
                          (y.charAt(y.length - 1) != "*")
                        ) {
                          comparatorResult = 0;
                        }
                      } else {
                        if (
                          x.replace("*", "").split(".")[2].split(",")[0] ==
                          y.replace("*", "").split(".")[2].split(",")[0]
                        ) {
                          if (
                            (x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                              y
                                .replace("*", "")
                                .split(".")[2]
                                .includes("amended")) ||
                            (!x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                              !y
                                .replace("*", "")
                                .split(".")[2]
                                .includes("amended"))
                          ) {
                            comparatorResult =
                              x.replace("*", "").split(".")[2] >
                              y.replace("*", "").split(".")[2]
                                ? 1
                                : x.replace("*", "").split(".")[2] ==
                                  y.replace("*", "").split(".")[2]
                                ? 0
                                : -1;
                          } else if (
                            !x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                            y.replace("*", "").split(".")[2].includes("amended")
                          ) {
                            comparatorResult = -1;
                          } else if (
                            x
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended") &&
                            !y
                              .replace("*", "")
                              .split(".")[2]
                              .includes("amended")
                          ) {
                            comparatorResult = 1;
                          }
                        } else {
                          comparatorResult =
                            Number(
                              x.replace("*", "").split(".")[2].split(",")[0]
                            ) -
                            Number(
                              y.replace("*", "").split(".")[2].split(",")[0]
                            );
                        }
                      }
                    }
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split(".")[1]) -
                      Number(y.replace("*", "").split(".")[1]);
                  }
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (!x.includes(".") && y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = -1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else if (x.includes(".") && !y.includes(".")) {
                if (
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) ==
                  Number(y.replace("*", "").split("Q")[1].split(".")[0])
                ) {
                  comparatorResult = 1;
                } else {
                  comparatorResult =
                    Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                    Number(y.replace("*", "").split("Q")[1].split(".")[0]);
                }
              } else {
                comparatorResult =
                  Number(x.replace("*", "").split("Q")[1].split(".")[0]) -
                  Number(y.replace("*", "").split("Q")[1].split(".")[0]);
              }
            } else {
              comparatorResult =
                Number(x.substr(2, x.length - 2)) -
                Number(y.substr(2, y.length - 2));
            }
          }
        } else if (!x.includes("Q") && y.includes("Q")) {
          comparatorResult = 1;
        } else if (x.includes("Q") && !y.includes("Q")) {
          comparatorResult = -1;
        }
      }
    }
    if (comparatorResult == 0) {
      if (x.toLowerCase().includes("fn") || y.toLowerCase().includes("fn")) {
        if (x.toLowerCase().includes("fn") && y.toLowerCase().includes("fn")) {
          x = x.replace("–", "-");
          y = y.replace("–", "-");
          if (
            this.checkNumber(
              x.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            ) &&
            this.checkNumber(
              y.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            )
          ) {
            if (
              Number(
                x.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
              ) ==
              Number(
                y.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
              )
            ) {
              if (
                x.toLowerCase().replace("*", "").split("fn")[1].includes("-") &&
                y.toLowerCase().replace("*", "").split("fn")[1].includes("-")
              ) {
                if (
                  Number(x.toLowerCase().replace("*", "").split("fn")[2]) ==
                  Number(y.toLowerCase().replace("*", "").split("fn")[2])
                ) {
                  if (
                    (x.charAt(x.length - 1) != "*") &&
                    y.charAt(y.length - 1) == "*"
                  ) {
                    comparatorResult = 1;
                  } else if (
                    x.charAt(x.length - 1) == "*" &&
                    (y.charAt(y.length - 1) != "*")
                  ) {
                    comparatorResult = -1;
                  }
                } else {
                  comparatorResult =
                    Number(x.toLowerCase().replace("*", "").split("fn")[2]) -
                    Number(y.toLowerCase().replace("*", "").split("fn")[2]);
                }
              } else {
                if (
                  (x.includes("*") && y.includes("*")) ||
                  (!x.includes("*") && !y.includes("*"))
                ) {
                  comparatorResult =
                    Number(x.toLowerCase().replace("*", "").split("fn")[1]) -
                    Number(y.toLowerCase().replace("*", "").split("fn")[1]);
                } else if (
                  (x.charAt(x.length - 1) != "*") &&
                  y.charAt(y.length - 1) == "*"
                ) {
                  comparatorResult = 1;
                } else if (
                  x.charAt(x.length - 1) == "*" &&
                  (y.charAt(y.length - 1) != "*")
                ) {
                  comparatorResult = -1;
                }
              }
            } else {
              comparatorResult =
                Number(
                  x.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
                ) -
                Number(
                  y.toLowerCase().replace("*", "").split("fn")[1].split("-")[0]
                );
            }
          } else if (
            !this.checkNumber(
              x.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            ) &&
            this.checkNumber(
              y.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            )
          ) {
            comparatorResult = 1;
          } else if (
            this.checkNumber(
              x.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            ) &&
            !this.checkNumber(
              y.toLowerCase().replace("*", "").split("fn")[1].charAt(0)
            )
          ) {
            comparatorResult = -1;
          } else {
            comparatorResult =
              Number(x.toLowerCase().substr(2, x.length - 2)) -
              Number(y.toLowerCase().substr(2, y.length - 2));
          }
        } else if (
          !x.toLowerCase().includes("fn") &&
          y.toLowerCase().includes("fn")
        ) {
          comparatorResult = 1;
        } else if (
          x.toLowerCase().includes("fn") &&
          !y.toLowerCase().includes("fn")
        ) {
          comparatorResult = -1;
        }
      }
    }
    if (
      comparatorResult == 0 &&
      x.charAt(0) != "¶" &&
      x.charAt(0) != "Q" &&
      x.charAt(0).toLowerCase() != "f"
    ) {
      if (
        !this.checkNumber(x.split("")[0]) ||
        !this.checkNumber(y.split("")[0])
      ) {
        if (
          !this.checkNumber(x.split("")[0]) &&
          !this.checkNumber(y.split("")[0])
        ) {
          if (this.onlyGlossary(a) && this.onlyGlossary(b)) {
            comparatorResult = x > y ? 1 : x == y ? 0 : -1;
          } else if (this.onlyGlossary(a) || this.onlyGlossary(b)) {
            if (this.onlyGlossary(a) && !this.onlyGlossary(b)) {
              return -1;
            } else {
              return 1;
            }
          } else {
            if (x.includes(" ") && y.includes(" ")) {
              if (x.split(" ")[0] == y.split(" ")[0]) {
                if (
                  x.split(" ")[1].includes("-") &&
                  y.split(" ")[1].includes("-")
                ) {
                  if (
                    x.split(" ")[1].split("-")[0] ==
                    y.split(" ")[1].split("-")[0]
                  ) {
                    comparatorResult =
                      Number(x.split(" ")[1].split("-")[1]) -
                      Number(y.split(" ")[1].split("-")[1]);
                  } else {
                    comparatorResult =
                      Number(x.split(" ")[1].split("-")[0]) -
                      Number(y.split(" ")[1].split("-")[0]);
                  }
                } else {
                  if (x.includes(", Ex") && y.includes(", Ex")) {
                    if (x.split(" ")[1] == y.split(" ")[1]) {
                      comparatorResult =
                        Number(
                          x.split(" ")[x.split(" ").length - 1].split("–")[0]
                        ) -
                        Number(
                          y.split(" ")[y.split(" ").length - 1].split("–")[0]
                        );
                    } else {
                      comparatorResult =
                        x.split(" ")[1] > y.split(" ")[1]
                          ? 1
                          : x.split(" ")[1] == y.split(" ")[1]
                          ? 0
                          : -1;
                    }
                  } else if (
                    x.toLowerCase().includes("not") &&
                    y.toLowerCase().includes("not")
                  ) {
                    comparatorResult = x > y ? 1 : x == y ? 0 : -1;
                  } else {
                    comparatorResult =
                      Number(x.split(" ")[1]) - Number(y.split(" ")[1]);
                  }
                }
              } else {
                comparatorResult =
                  x.split(" ")[0] > y.split(" ")[0]
                    ? 1
                    : x.split(" ")[0] == y.split(" ")[0]
                    ? 0
                    : -1;
              }
            } else if (!x.includes(" ") && y.includes(" ")) {
              if (x == y.split(" ")[0]) {
                comparatorResult = -1;
              } else {
                comparatorResult = x > y.split(" ")[0] ? 1 : -1;
              }
            } else if (x.includes(" ") && !y.includes(" ")) {
              if (x.split(" ")[0] == y) {
                comparatorResult = 1;
              } else {
                comparatorResult = x.split(" ")[0] > y ? 1 : -1;
              }
            } else {
              comparatorResult =
                x.replace("*", "") > y.replace("*", "")
                  ? 1
                  : x.replace("*", "") == y.replace("*", "")
                  ? 0
                  : -1;
            }
          }
        } else if (
          !this.checkNumber(x.split("")[0]) &&
          this.checkNumber(y.split("")[0])
        ) {
          comparatorResult = -1;
        } else if (
          this.checkNumber(x.split("")[0]) &&
          !this.checkNumber(y.split("")[0])
        ) {
          comparatorResult = 1;
        }
      }
    }
    if (comparatorResult == 0) {
      if (
        (x.includes("*") && y.includes("*")) ||
        (!x.includes("*") && !y.includes("*"))
      ) {
        if (x.includes(".") && y.includes(".")) {
          if (
            x.replace("*", "").split(".")[0] == y.replace("*", "").split(".")[0]
          ) {
            if (
              Number(x.replace("*", "").split(".")[1]) ==
              Number(y.replace("*", "").split(".")[1])
            ) {
              if (x.split(".").length > 2 && y.split(".").length > 2) {
                if (
                  x.replace("*", "").split(".")[2] ==
                  y.replace("*", "").split(".")[2]
                ) {
                  if (
                    (x.charAt(x.length - 1) != "*") &&
                    y.charAt(y.length - 1) == "*"
                  ) {
                    comparatorResult = 1;
                  } else if (
                    x.charAt(x.length - 1) == "*" &&
                    (y.charAt(y.length - 1) != "*")
                  ) {
                    comparatorResult = -1;
                  } else if (
                    (x.charAt(x.length - 1) != "*") &&
                    (y.charAt(y.length - 1) != "*")
                  ) {
                    comparatorResult = 0;
                  }
                } else {
                  if (
                    x.replace("*", "").split(".")[2].split(",")[0] ==
                    y.replace("*", "").split(".")[2].split(",")[0]
                  ) {
                    if (
                      (x.replace("*", "").split(".")[2].includes("amended") &&
                        y.replace("*", "").split(".")[2].includes("amended")) ||
                      (!x.replace("*", "").split(".")[2].includes("amended") &&
                        !y.replace("*", "").split(".")[2].includes("amended"))
                    ) {
                      comparatorResult =
                        x.replace("*", "").split(".")[2] >
                        y.replace("*", "").split(".")[2]
                          ? 1
                          : x.replace("*", "").split(".")[2] ==
                            y.replace("*", "").split(".")[2]
                          ? 0
                          : -1;
                    } else if (
                      !x.replace("*", "").split(".")[2].includes("amended") &&
                      y.replace("*", "").split(".")[2].includes("amended")
                    ) {
                      comparatorResult = -1;
                    } else if (
                      x.replace("*", "").split(".")[2].includes("amended") &&
                      !y.replace("*", "").split(".")[2].includes("amended")
                    ) {
                      comparatorResult = 1;
                    }
                  } else {
                    comparatorResult =
                      Number(x.replace("*", "").split(".")[2].split(",")[0]) -
                      Number(y.replace("*", "").split(".")[2].split(",")[0]);
                  }
                }
              }
            } else {
              comparatorResult =
                Number(x.replace("*", "").split(".")[1]) -
                Number(y.replace("*", "").split(".")[1]);
            }
          } else {
            comparatorResult =
              Number(x.replace("*", "").split(".")[0]) -
              Number(y.replace("*", "").split(".")[0]);
          }
        } else if (!x.includes(".") && y.includes(".")) {
          if (
            Number(x.replace("*", "").split(".")[0]) ==
            Number(y.replace("*", "").split(".")[0])
          ) {
            comparatorResult = -1;
          } else {
            comparatorResult =
              Number(x.replace("*", "").split(".")[0]) -
              Number(y.replace("*", "").split(".")[0]);
          }
        } else if (x.includes(".") && !y.includes(".")) {
          if (
            Number(x.replace("*", "").split(".")[0]) ==
            Number(y.replace("*", "").split(".")[0])
          ) {
            comparatorResult = 1;
          } else {
            comparatorResult =
              Number(x.replace("*", "").split(".")[0]) -
              Number(y.replace("*", "").split(".")[0]);
          }
        } else {
          comparatorResult =
            Number(x.replace("*", "").split(".")[0].replace(/\D/g, "")) -
            Number(y.replace("*", "").split(".")[0].replace(/\D/g, ""));
        }
      } else if (!x.includes("*") && y.includes("*")) {
        if (x.replace("*", "") == y.replace("*", "")) {
          comparatorResult = -1;
        } else {
          comparatorResult =
            x.replace("*", "") > y.replace("*", "")
              ? 1
              : x.replace("*", "") == y.replace("*", "")
              ? 0
              : -1;
        }
      } else if (x.includes("*") && !y.includes("*")) {
        if (x.replace("*", "") == y.replace("*", "")) {
          comparatorResult = 1;
        } else {
          comparatorResult =
            x.replace("*", "") > y.replace("*", "")
              ? 1
              : x.replace("*", "") == y.replace("*", "")
              ? 0
              : -1;
        }
      }
    }
    return comparatorResult;
  }

  SortSTTbySection(a: any, b: any) {
    let comparatorResult = 0;
    let spanA = document.createElement("span");
    spanA.innerHTML = a.section;
    let x = spanA.innerText.trim().toLowerCase();
    let spanB = document.createElement("span");
    spanB.innerHTML = b.section;
    let y = spanB.innerText.trim().toLowerCase();
    //Start - Added this code to correct sorting order MS-689
    // Summary:
    // pattern QZ.CN.NN causing issue with sorting order where C: Character & N:Number
    // Ex: 1) QZ.I1.1
    //     2) QZ.I2.1
    if (x.includes("QZ.I")) x = x.replace("QZ.I", "QZ.9999");
    if (y.includes("QZ.I")) y = y.replace("QZ.I", "QZ.9999");
    if (this.matchAppendixPattern(x)) { x = x.replace("Appendix ", "Appendix _"); }
    if (this.matchAppendixPattern(y)) { y = y.replace("Appendix ", "Appendix _"); }
    if (x.includes("Appendix BZ")) x = x.replace(/BZ/g, '10000');
    if (y.includes("Appendix BZ")) y = y.replace(/BZ/g, '10000');
    if (x.includes("Appendix BZ")) { x = x.replace(/BZ/g, '100000'); }
    if (y.includes("Appendix BZ")) { y = y.replace(/BZ/g, '100000'); }
    if (x.includes("Appendix B")) x = x.replace(/B(\d+)/g, '999$1');
    if (y.includes("Appendix B")) y = y.replace(/B(\d+)/g, '999$1');
    if (x.includes("Appendix _")) x = x.replace(/_(\d+)/g, '99$1');
    if (y.includes("Appendix _")) y = y.replace(/_(\d+)/g, '99$1');
    if (x.includes("Appendix ")) x = x.replace(/-/g, '.');
    if (y.includes("Appendix ")) y = y.replace(/-/g, '.');
    //End - Added this code to correct sorting order MS-689
    if (x == "" && y != "") { comparatorResult = -1; }
    else if (x != "" && y == "") { comparatorResult = 1; }
    else if (x == "" && y == "") { comparatorResult = 0; }
    else if (!this.isFootnote(a) && this.isFootnote(b)) { comparatorResult = -1; }
    else if (this.isFootnote(a) && !this.isFootnote(b)) { comparatorResult = 1; }
    else if (this.checkNumber(x.split("")[0]) && this.checkNumber(y.split("")[0])) {
      if (x.includes(".") && y.includes(".")) {
        if (Number(x.split(".")[0]) == Number(y.split(".")[0])) {
          if (x.split(".")[1].includes("-") && !y.split(".")[1].includes("-")) {
            if (y.toLowerCase().split(".")[1].includes("fn")) {
              comparatorResult = -1;
            } else {
              if (
                Number(x.split(".")[1].split("-")[0]) == Number(y.split(".")[1])
              ) {
                comparatorResult = 1;
              } else {
                comparatorResult =
                  Number(x.split(".")[1].split("-")[0]) -
                  Number(y.split(".")[1]);
              }
            }
          } else if (
            !x.split(".")[1].includes("-") &&
            y.split(".")[1].includes("-")
          ) {
            if (x.toLowerCase().split(".")[1].includes("fn")) {
              comparatorResult = -1;
            } else {
              if (
                Number(x.split(".")[1]) == Number(y.split(".")[1].split("-")[0])
              ) {
                comparatorResult = -1;
              } else {
                comparatorResult =
                  Number(x.split(".")[1]) -
                  Number(y.split(".")[1].split("-")[0]);
              }
            }
          } else if (
            x.split(".")[1].includes("-") &&
            y.split(".")[1].includes("-")
          ) {
            if (
              x.split(".")[1].split("-")[0] != y.split(".")[1].split("-")[0]
            ) {
              comparatorResult =
                Number(x.split(".")[1].split("-")[0]) -
                Number(y.split(".")[1].split("-")[0]);
            } else {
              comparatorResult =
                Number(x.split(".")[1].split("-")[1]) -
                Number(y.split(".")[1].split("-")[1]);
            }
          } else {
            comparatorResult =
              Number(
                x
                  .split(".")[1]
                  .split(" ")[0]
                  .replace("fn", "")
                  .replace("Fn", "")
              ) -
              Number(
                y
                  .split(".")[1]
                  .split(" ")[0]
                  .replace("fn", "")
                  .replace("Fn", "")
              );
          }
        } else {
          comparatorResult = Number(x.split(".")[0]) - Number(y.split(".")[0]);
        }
      } else if (!x.includes(".") && y.includes(".")) {
        if (Number(x) == Number(y.split(".")[0])) {
          comparatorResult = -1;
        } else {
          comparatorResult = Number(x) - Number(y.split(".")[0]);
        }
      } else if (x.includes(".") && !y.includes(".")) {
        if (Number(x.split(".")[0]) == Number(y)) {
          comparatorResult = 1;
        } else {
          comparatorResult = Number(x.split(".")[0]) - Number(y);
        }
      } else {
        comparatorResult = Number(x) - Number(y);
      }
    } else if (
      !this.checkNumber(x.split("")[0]) &&
      this.checkNumber(y.split("")[0])
    ) {
      comparatorResult = 1;
    } else if (
      this.checkNumber(x.split("")[0]) &&
      !this.checkNumber(y.split("")[0])
    ) {
      comparatorResult = -1;
    } else if (
      !this.checkNumber(x.split("")[0]) &&
      !this.checkNumber(y.split("")[0])
    ) {
      if (x.replace(/[^A-Za-z]/g, "") == y.replace(/[^A-Za-z]/g, "")) {
        if (x.includes(".") && y.includes(".")) {
          if (x.split(".")[0] == y.split(".")[0]) {
            if (
              x.split(".")[1].includes("-") &&
              !y.split(".")[1].includes("-")
            ) {
              if (y.split(".")[1].includes("fn")) {
                comparatorResult = -1;
              } else {
                if (
                  Number(x.split(".")[1].split("-")[0]) ==
                  Number(y.split(".")[1])
                ) {
                  comparatorResult = 1;
                } else {
                  comparatorResult =
                    Number(x.split(".")[1].split("-")[0]) -
                    Number(y.split(".")[1]);
                }
              }
            } else if (
              !x.split(".")[1].includes("-") &&
              y.split(".")[1].includes("-")
            ) {
              if (x.split(".")[1].includes("fn")) {
                comparatorResult = -1;
              } else {
                if (
                  Number(x.split(".")[1]) ==
                  Number(y.split(".")[1].split("-")[0])
                ) {
                  comparatorResult = -1;
                } else {
                  comparatorResult =
                    Number(x.split(".")[1]) -
                    Number(y.split(".")[1].split("-")[0]);
                }
              }
            } else if (
              x.split(".")[1].includes("-") &&
              y.split(".")[1].includes("-")
            ) {
              if (
                x.split(".")[1].split("-")[0] != y.split(".")[1].split("-")[0]
              ) {
                comparatorResult =
                  Number(x.split(".")[1].split("-")[0]) -
                  Number(y.split(".")[1].split("-")[0]);
              } else {
                comparatorResult =
                  Number(x.split(".")[1].split("-")[1]) -
                  Number(y.split(".")[1].split("-")[1]);
              }
            } else {
              if (
                x.split(".")[1].includes("fn") &&
                y.split(".")[1].includes("fn")
              ) {
                comparatorResult =
                  Number(x.split(".")[1].split("fn")[1]) -
                  Number(y.split(".")[1].split("fn")[1]);
              } else if (
                !x.split(".")[1].includes("fn") &&
                y.split(".")[1].includes("fn")
              ) {
                if (
                  Number(x.split(".")[1]) ==
                  Number(y.split(".")[1].split("fn")[1])
                ) {
                  comparatorResult = -1;
                } else {
                  comparatorResult =
                    Number(x.split(".")[1]) -
                    Number(y.split(".")[1].split("fn")[1]);
                }
              } else if (
                x.split(".")[1].includes("fn") &&
                !y.split(".")[1].includes("fn")
              ) {
                if (
                  Number(x.split(".")[1].split("fn")[1]) ==
                  Number(y.split(".")[1])
                ) {
                  comparatorResult = 1;
                } else {
                  comparatorResult =
                    Number(x.split(".")[1].split("fn")[1]) -
                    Number(y.split(".")[1]);
                }
              } else {
                comparatorResult =
                  Number(x.split(".")[1]) - Number(y.split(".")[1]);
              }
            }
          } else {
            comparatorResult =
              x.split(".")[0] > y.split(".")[0]
                ? 1
                : x.split(".")[0] == y.split(".")[0]
                ? 0
                : -1;
          }
        } else if (!x.includes(".") && y.includes(".")) {
          if (this.onlyLetters(x)) {
            if (x.length == 1) {
              comparatorResult = x > y.charAt(0) ? 1 : -1;
            } else {
              comparatorResult = 1;
            }
          } else if (x.charAt(0) == y.charAt(0)) {
            if (x == y.split(".")[0]) {
              comparatorResult = -1;
            } else {
              comparatorResult =
                x > y.split(".")[0] ? 1 : x == y.split(".")[0] ? 0 : -1;
            }
          } else {
            comparatorResult =
              x.charAt(0) > y.charAt(0)
                ? 1
                : x.charAt(0) == y.charAt(0)
                ? 0
                : -1;
          }
        } else if (x.includes(".") && !y.includes(".")) {
          if (this.onlyLetters(y)) {
            if (y.length == 1) {
              comparatorResult = x.charAt(0) < y ? -1 : 1;
            } else {
              comparatorResult = -1;
            }
          } else if (x.charAt(0) == y.charAt(0)) {
            if (x.split(".")[0] == y) {
              comparatorResult = 1;
            } else {
              comparatorResult =
                x.split(".")[0] > y ? 1 : x.split(".")[0] == y ? 0 : -1;
            }
          } else {
            if (this.onlyLetters(x) && this.onlyLetters(y)) {
              comparatorResult =
                x.charAt(0) > y.charAt(0)
                  ? 1
                  : x.charAt(0) == y.charAt(0)
                  ? 0
                  : -1;
            } else if (this.onlyLetters(x) && !this.onlyLetters(y)) {
              comparatorResult = 1;
            } else if (!this.onlyLetters(x) && this.onlyLetters(y)) {
              comparatorResult = -1;
            } else {
              comparatorResult =
                x.replace(/[^A-Za-z]/g, "") > y.replace(/[^A-Za-z]/g, "")
                  ? 1
                  : x.replace(/[^A-Za-z]/g, "") == y.replace(/[^A-Za-z]/g, "")
                  ? 0
                  : -1;
            }
          }
        } else {
          if (x.match(/(\d+)/) != null && y.match(/(\d+)/) != null) {
            comparatorResult =
              Number(x.match(/(\d+)/)[0]) - Number(y.match(/(\d+)/)[0]);
          }
          if (x.match(/(\d+)/) == null && y.match(/(\d+)/) != null) {
            comparatorResult = -1;
          }
          if (x.match(/(\d+)/) != null && y.match(/(\d+)/) == null) {
            comparatorResult = 1;
          }
        }
      } else {
        if (this.onlyGlossary(a) && this.onlyGlossary(b)) {
          if (x.length == 1 && y.length > 1) {
            comparatorResult = -1;
          } else if (x.length > 1 && y.length == 1) {
            comparatorResult = 1;
          } else {
            if (a.section.includes("<a") && !b.section.includes("<a")) {
              comparatorResult = -1;
            } else if (!a.section.includes("<a") && b.section.includes("<a")) {
              comparatorResult = 1;
            } else {
              comparatorResult =
                x.replace(/[^A-Za-z (A-Za-z)]/g, "") >
                y.replace(/[^A-Za-z (A-Za-z)]/g, "")
                  ? 1
                  : x.replace(/[^A-Za-z (A-Za-z)]/g, "") ==
                    y.replace(/[^A-Za-z (A-Za-z)]/g, "")
                  ? 0
                  : -1;
            }
          }
        } else if (this.onlyGlossary(a) && !this.onlyGlossary(b)) {
          if (x.length == 1) {
            comparatorResult = x > y.charAt(0) ? 1 : x == y.charAt(0) ? 0 : -1;
          } else {
            if (y.toLowerCase().includes("superseded")) {
              comparatorResult =
                x.replace(/[^A-Za-z (A-Za-z)]/g, "") >
                y.replace(/[^A-Za-z (A-Za-z)]/g, "")
                  ? 1
                  : x.replace(/[^A-Za-z (A-Za-z)]/g, "") ==
                    y.replace(/[^A-Za-z (A-Za-z)]/g, "")
                  ? 0
                  : -1;
            } else {
              comparatorResult = 1;
            }
          }
        } else if (!this.onlyGlossary(a) && this.onlyGlossary(b)) {
          if (y.length == 1) {
            comparatorResult = x.charAt(0) > y ? 1 : x.charAt(0) == y ? 0 : -1;
          } else {
            if (x.toLowerCase().includes("superseded")) {
              comparatorResult =
                x.replace(/[^A-Za-z (A-Za-z)]/g, "") >
                y.replace(/[^A-Za-z (A-Za-z)]/g, "")
                  ? 1
                  : x.replace(/[^A-Za-z (A-Za-z)]/g, "") ==
                    y.replace(/[^A-Za-z (A-Za-z)]/g, "")
                  ? 0
                  : -1;
            } else {
              comparatorResult = -1;
            }
          }
        } else {
          if (
            x.replace(/[^A-Za-z]/g, "").length > 2 &&
            y.replace(/[^A-Za-z]/g, "").length > 2
          ) {
            //NOSONAR typescript:S1871
            comparatorResult =
              x.replace(/[^A-Za-z]/g, "") > y.replace(/[^A-Za-z]/g, "")
                ? 1
                : x.replace(/[^A-Za-z]/g, "") == y.replace(/[^A-Za-z]/g, "")
                ? 0
                  : -1;
          } else if (
            x.replace(/[^A-Za-z]/g, "").length <= 2 &&
            y.replace(/[^A-Za-z]/g, "").length > 2
          ) {
            comparatorResult = -1;
          } else if (
            x.replace(/[^A-Za-z]/g, "").length > 2 &&
            y.replace(/[^A-Za-z]/g, "").length <= 2
          ) {
            comparatorResult = 1;
          } else {
            /* eslint-disable */
            comparatorResult =
              x.replace(/[^A-Za-z]/g, "") > y.replace(/[^A-Za-z]/g, "")
                ? 1
                : x.replace(/[^A-Za-z]/g, "") == y.replace(/[^A-Za-z]/g, "")
                ? 0
                  : -1;
            /* eslint-enable */
          }
        }
      }
    }
    return comparatorResult;
  }
}
